import { Theme } from '@mui/material/styles';

export const dialogRadius = (phone: boolean) => (theme: Theme) =>
  phone
    ? `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`
    : `${theme.shape.borderRadius}px`;

/** Shared surface treatment; the shell alone owns the device safe-area inset. */
export const dialogSurface = (phone: boolean) => ({
  maxHeight: phone ? '100dvh' : 'min(90dvh, 760px)',
  '@supports not (height: 100dvh)': {
    maxHeight: phone ? '100vh' : 'min(90vh, 760px)',
  },
  border: 0,
  backgroundImage: 'none',
  borderRadius: dialogRadius(phone),
  pb: phone ? 'env(safe-area-inset-bottom)' : 0,
});
